import type {
  CourierDeliveryScheduleCreateRequestType,
  CourierDeliveryScheduleCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCourierDeliveryScheduleCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CourierDeliveryScheduleCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `courier-delivery-schedule`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as CourierDeliveryScheduleCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.CourierDeliverySchedule,
        ],
      });
    },
  });
};
